import { useQuery } from '@apollo/client';

import { queryParams } from 'app/shared/utils/queries';
import { ArtistPublicProfile } from 'app/shared/typings/artists';
import { SharedGetDataParameters } from 'app/shared/typings/generics';
import { GET_ARTIST_PUBLIC_PROFILE } from 'app/fan/graphql/artists/queries';

interface GetArtistPublicProfileVariables extends SharedGetDataParameters {
  id?: number;
  cachedSlug?: string;
}

interface GetArtistPublicProfileData {
  artist: ArtistPublicProfile;
}

export const GetArtistPublicProfile = (
  params: GetArtistPublicProfileVariables = {}
) => {
  return useQuery<GetArtistPublicProfileData>(
    GET_ARTIST_PUBLIC_PROFILE,
    queryParams(params)
  );
};
